import { TimeUnitPlural } from '../types';

export const DATE_UNIT_PLURAL_TO_DEFAULT_AMOUNT_MAP: Record<
  TimeUnitPlural,
  string
> = {
  [TimeUnitPlural.HOURS]: '24',
  [TimeUnitPlural.DAYS]: '7',
  [TimeUnitPlural.WEEKS]: '4',
  [TimeUnitPlural.MONTHS]: '12',
};
